@if (environment.newAuthPages) {
<app-auth-shell mode="confirm">
  <form [formGroup]="form" (ngSubmit)="confirm()" class="auth-form">
    <h1 class="auth-title">Confirm your login</h1>
    <p class="auth-subtitle">Check your email for the confirmation code.</p>

    @if (!showInputs) {
      <button data-cy="manualinput-button" type="button" class="auth-btn auth-btn-secondary"
        (click)="showInputs=true">Or click here to enter the code manually</button>
    }

    @if (showInputs) {
      <div class="auth-field">
        <label for="confirm-email">Email</label>
        <input type="text" data-cy="email-input" class="auth-input" id="confirm-email" formControlName="email"
          required placeholder="you@company.com">
        @if (form.get('email')?.touched && form.get('email')?.invalid) {
          <div class="auth-field-error">An email address is required.</div>
        }
      </div>

      <div class="auth-field">
        <label for="confirm-code">Confirmation code</label>
        <input type="text" data-cy="confirm-input" class="auth-input" id="confirm-code" formControlName="code"
          required placeholder="Code">
        @if (form.get('code')?.touched && form.get('code')?.invalid) {
          <div class="auth-field-error">A confirmation code is required.</div>
        }
      </div>
    }

    @if (busy) {
      <simple-progress [message]='message'></simple-progress>
    } @else {
      @if (showInputs) {
        <button data-cy="confirm-button" type="submit" class="auth-btn auth-btn-block"
          [disabled]="!form.valid">Confirm</button>
      }
      <button data-cy="resend-button" type="button" class="auth-btn auth-btn-secondary auth-btn-block"
        (click)="resend()">Resend</button>
    }

    @if (!!error) {
      <app-warning-panel id="error" [error]='true'>{{error}}</app-warning-panel>
    }
  </form>
</app-auth-shell>
} @else {
<style>
  .main {
  margin-top: 10em;
}
</style>
<app-bganimation tagName="body" className="warehouse"></app-bganimation>
<div class="main wider layout-row layout-align-center layout-justify-center">
  <form [formGroup]="form" (ngSubmit)="confirm()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Confirm Your Login</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Check your email for the confirmation code.</p>
        @if (!showInputs) {
          <p>
            <button data-cy="manualinput-button" mat-raised-button (click)="showInputs=true">Or click
              here to enter the code manually.
            </button>
          </p>
        }
        @if (showInputs) {
          <div class="layout-row-gap-1 layout-align-start">
            <div class="layout-col">
              <mat-form-field class="wide">
                <mat-label>Email</mat-label>
                <input type="text" data-cy="email-input" matInput formControlName="email" required placeholder="Email">
                <mat-error>Required</mat-error>
              </mat-form-field>
              <mat-form-field class="wide">
                <mat-label>Confirmation Code</mat-label>
                <input type="text" data-cy="confirm-input" matInput formControlName="code" required placeholder="Code">
                <mat-error>Required</mat-error>
              </mat-form-field>
            </div>
          </div>
        }
      </mat-card-content>
      <mat-card-actions>
        <div class="layout-col-gap-05">
          <div>
            @if (!!busy) {
              <simple-progress [message]='message'></simple-progress>
            } @else {
              @if (showInputs) {
                <button data-cy="confirm-button" mat-raised-button color="primary" type="submit"
                  [disabled]="!form.valid">Confirm
                </button>
              }
              <button data-cy="resend-button" mat-raised-button color="primary" (click)="resend()">Resend</button>
            }
          </div>
          <div>
            @if (!!error) {
              <app-warning-panel id="error" [error]='true'>{{error}}</app-warning-panel>
            }
          </div>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
}
